<template>
  <div id="main-wrapper">
    <div v-if="store.trans_id && (store.trans_id_type == 'BONUS' || store.trans_id_type == 'REMOVE_BONUS')">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-center">
                <p v-if="store.trans_id_type == 'BONUS'">{{$t('bonus.request_to_avail_bonus')}} {{static_vars.currency[store.lastSelectedAccount.currency]}}{{amount}} {{$t('bonus.trading_id')}} {{store.lastSelectedAccount.account_id}} {{$t('bonus.click_confirmation_link')}}</p>
                <p v-if="store.trans_id_type == 'REMOVE_BONUS'">{{$t('bonus.request_to_remove_bonus')}} {{static_vars.currency[store.lastSelectedAccount.currency]}}{{amount}} {{$t('bonus.trading_id')}} {{store.lastSelectedAccount.account_id}} {{$t('bonus.click_confirmation_link')}}</p>
                <SuccessBox
                    type="bonus"
                  />
              </div>
              <!-- <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="resetAndBack">OK </a>
              </div> -->
              <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="resetAndBack">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="content-container profile-page deposit-live transactions-dep bonus-page"
    >
      <div v-if="showRemoveModal">
        <div class="mfp-bg animated zoomIn mfp-ready"></div>
        <div
          class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready"
          tabindex="-1"
          style="overflow: hidden auto"
        >
          <div class="mfp-container mfp-s-ready mfp-inline-holder">
            <div class="mfp-content">
              <div
                id="upload-confirm"
                class="white-popup-block popup-content popup-small"
              >
                <div class="content t-white t-left">
                  <p >
                    {{$t('bonus.bonus_amount')}} {{static_vars.currency[store.lastSelectedAccount.currency]}}{{ bonusRemoved }} {{$t('bonus.successfully_removed_account')}}
                    {{ store.lastSelectedAccount.account_id }}
                  </p>
                </div>
                <div class="btn-holder t-center">
                  <a
                    href="#"
                    class="btn btn-lblue close-popup"
                    @click.prevent="showRemoveModal = false"
                    >{{$t('bonus.ok')}}
                  </a>
                </div>
                <button
                  title="Close (Esc)"
                  type="button"
                  class="mfp-close"
                  @click.prevent="showRemoveModal = false"
                >
                  ×
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showAddModal">
        <div class="mfp-bg animated zoomIn mfp-ready"></div>
        <div
          class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready"
          tabindex="-1"
          style="overflow: hidden auto"
        >
          <div class="mfp-container mfp-s-ready mfp-inline-holder">
            <div class="mfp-content">
              <div
                id="upload-confirm"
                class="white-popup-block popup-content popup-small"
              >
                <div class="content t-white t-left">
                  <p >
                    {{$t('bonus.request_to_add_bonus')}} {{static_vars.currency[store.lastSelectedAccount.currency]}}{{amount}} {{$t('bonus.trading_id')}} {{store.lastSelectedAccount.account_id}} {{$t('bonus.successfully')}}
                  </p>
                </div>
                <div class="btn-holder t-center">
                  <a
                    href="#"
                    class="btn btn-lblue close-popup"
                    @click.prevent="showAddModal = false"
                    >{{$t('bonus.ok')}}
                  </a>
                </div>
                <button
                  title="Close (Esc)"
                  type="button"
                  class="mfp-close"
                  @click.prevent="showAddModal = false"
                >
                  ×
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="page-wrap">
        <div class="page-content clearfix">
          <div class="main-content f-left">
            <div class="content-holder">
              <div class="dep-nav">
                <ul>
                  <li class="active">
                    <router-link to="/bonus">{{$t('bonus.bonus')}}</router-link>
                  </li>
                  <!--  <li>
                    <router-link to="/refer-earn">REFER AND EARN</router-link>
                  </li> -->
                </ul>
              </div>
              <br />
              <!-- <div
                v-if="
                  store.trans_id &&
                  (store.trans_id_type == 'BONUS' ||
                    store.trans_id_type == 'REMOVE_BONUS')
                "
              >
                <SuccessBox type="bonus" />
              </div> -->
              <Form @submit="submit">
                <div>
                  <div class="form-holder acct-transfer">
                    <ul class="clearfix">
                      <li class="f-left">
                        <label for="">{{$t('bonus.select_trading_id')}}</label>
                        <select class="form-control" name="account" v-model="store.lastSelectedAccount.account_id"  @change="GetTradingAccountDetail">
                          <option value="" label="Select Trading ID">{{$t('bonus.select_trading_id')}}</option>
                          <optgroup label="Live MT4">
                            <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT4')" :key ="index" >{{list.account_id}}</option>
                          </optgroup>
                          <optgroup label="Live MT5">
                            <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT5')" :key ="index" >{{list.account_id}}</option>
                          </optgroup>
                          <optgroup label="Live ZTP">
                            <option :value="list.account_id" v-for="list,index in MergeAcc('1','ZTP')" :key ="index" >{{list.account_id}}</option>
                          </optgroup>
                      </select>
                      </li>
                      <!-- <li
                        v-if="
                          COMMON.convertStringToInteger(store.allowedBonus) > 0
                        "
                        class="f-right"
                      > -->
                      <li class="f-right">
                        <div class="currency">
                          <div class="position-relative w-100">
                            <Field
                              name="amount"
                              v-model="amount"
                              :rules="bonusRule"
                              placeholder="Enter Bonus Amount"
                            />
                            <button
                              type="button"
                              @click="amount = store.allowedBonus"
                              class="cur"
                            >
                              {{$t('bonus.use_max')}}
                              {{
                                COMMON.priceWithCurrency(
                                  store.lastSelectedAccount,
                                  COMMON.convertToTwoDecimalDigits(
                                    store.allowedBonus
                                  )
                                )
                              }}
                            </button>
                          </div>
                          <ErrorMessage name="amount" />
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="table-holder table-holder4 t-center">
                    <table>
                      <tr>
                        <th>{{$t('bonus.account_type')}}</th>
                        <th>{{$t('bonus.equity')}}</th>
                        <th>{{$t('bonus.leverage')}}</th>
                        <th>{{$t('bonus.currency')}}</th>
                        <th>{{$t('bonus.current_bonus')}}</th>
                        <th>{{$t('bonus.allowed_bonus')}}</th>
                      </tr>
                      <tr v-if="'account_id' in store.lastSelectedAccount">
                        <td>{{ store.lastSelectedAccount.account_type }}</td>
                        <td>
                          {{ store.tradingAccountDetail.margin_detail.equity }}
                        </td>
                        <td>{{ store.lastSelectedAccount.leverage }}X</td>
                        <td>{{ store.lastSelectedAccount.currency }}</td>
                        <td>
                          {{ COMMON.convertStringToInteger(store.tradingAccountDetail.margin_detail.credit) }}
                          <!-- <a
                            @click="removeBonus"
                            v-if="COMMON.convertStringToInteger(store.tradingAccountDetail.margin_detail.credit) > 0"
                            class="btn btn-blue btn-rem popup-link-holder"
                            >Remove</a
                          > -->
                          <a @click="removeBonus" class="btn btn-blue btn-rem popup-link-holder" v-if="forUser">{{$t('bonus.remove')}}</a>
                        </td>
                        <td> {{ COMMON.convertToTwoDecimalDigits(store.allowedBonus) }} </td>
                      </tr>
                      <tr v-else>
                        <td colspan="6" class="t-center">
                          <p>{{$t('bonus.account_first')}}</p>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="note">
                    <p>
                      <strong
                        >{{$t('bonus.bonus_amount_base_currency')}}</strong
                      >
                      <br /><br />
                      {{$t('bonus.point_one')}}
                      <br />
                      {{$t('bonus.point_two')}}
                      <br />
                      {{$t('bonus.point_three')}} <br />
                      {{$t('bonus.point_four')}}
                      <br />
                    </p>
                  </div>
                  <div class="form-holder bonus-form">
                    <li class="full-width d-flex">
                      <div class="checkbox checkbox2 w-auto">
                        <input type="checkbox" name="" v-model="accepted" />
                        <span></span>
                      </div>
                        <p>
                          {{$t('bonus.read_understood_accepted')}}
                          <a href="assets/pdf/AAAFx_Bonus_T&C_v1.pdf" target="_blank">{{$t('bonus.aaafx_bonus_policy')}}</a>
                        </p>
                      <span v-if="submitted && !accepted"
                        >{{$t('bonus.accept_aaafx_bonus_policy')}}</span
                      >
                    </li>
                  </div>
                  <div class="btn-holder t-left" style="margin-bottom: 5px">
                    <button
                      :disabled="
                        COMMON.convertStringToInteger(store.allowedBonus) == 0
                      "
                      type="submit"
                      class="btn btn-blue popup-link-holder"
                    >
                    {{$t('bonus.proceed')}}
                    </button>
                  </div>
                  <span
                    class="text-danger"
                    v-if="
                      COMMON.convertStringToInteger(store.allowedBonus) == 0
                    "
                  >
                  {{$t('bonus.no_bonus_available_account')}}
                  </span>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
//import AccountsDropdown from "@/components/shared/AccountsDropdown";
import { Form, Field, ErrorMessage } from "vee-validate";
import SuccessBox from "@/components/shared/SuccessBox";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  components: { /*AccountsDropdown,*/ Form, Field, ErrorMessage, SuccessBox },
  data() {
    return {
      isRemove: false,
      amount: 0,
      accepted: false,
      submitted: false,
      bonusRemoved: 0,
      showRemoveModal: false,
      showAddModal :false
    };
  },
  mounted() {
    if(this.store.lastSelectedAccount.length > 0){
      this.store.getAvailableBonus(this.store.lastSelectedAccount);
    }
  },
  computed:{
    forUser(){
      return this.store.user.profile.user_id == 20079;
    }
  },
  methods: {
    MergeAcc(acc_type,platform){
        let demoMT4 = this.store.tradingAccounts.records.filter(i => i.demo_live == acc_type && i.platform == platform).map(val => val)
        return demoMT4 || []
    },
    GetTradingAccountDetail(e){
      let acct = this.store.tradingAccounts.records.find(
        (i) => i.account_id == e.target.value
      );
      let keys = {
        dataRequired: {
          margin_detail: true,
          open_trades: false,
          history: false,
          account_detail: false,
        },
      };
       this.store.getAvailableBonus(acct);
      this.store.setLastSelectedAccount(acct, keys,false,'');
    },
    resetAndBack() {
      this.store.$patch({ trans_id: null });
    },
    bonusRule(val) {
      if (parseFloat(val) <= 100) {
        return "Please enter amount greater than 100";
      }
      if (parseFloat(val) > this.store.allowedBonus) {
        return "Amount cannot be greater than allowed bonus";
      }
      return true;
    },
    submit() {
      this.submitted = true;
      if (this.accepted) {
        this.submitted = false;
        let form = {
          account_id: this.store.lastSelectedAccount.account_id,
          act_account_id: "",
          amount: this.amount,
          operation: "BONUS",
        };
        this.store.accountOperations(form, true);
      }
    },
    removeBonus() {
      if (
        this.COMMON.convertStringToInteger(
          this.store.tradingAccountDetail.margin_detail.credit
        )
      ) {
        this.bonusRemoved =
          this.store.tradingAccountDetail.margin_detail.credit;
        this.isRemove = true;
        let form = {
          account_id: this.store.lastSelectedAccount.account_id,
          act_account_id: "",
          amount: this.store.tradingAccountDetail.margin_detail.credit,
          operation: "REMOVE_BONUS",
        };
        this.store.accountOperations(form, true);
        // .then(() => {
        //   this.showRemoveModal = true;
        //   this.store.getAccountDetails(this.store.lastSelectedAccount);
        // })
        // .catch((error) => {
        //   console.log(error);
        // });
      } else {
        window.alert("No bonus available");
      }


    },
    resend() {
      let form = {
        trans_id: this.store.trans_id,
      };
      this.store.resendOperationsLink(form, true);
    },
    verify() {
      let form = {
        type: this.isRemove ? "REMOVE_BONUS" : "BONUS",
        google_token: this.google_token,
        trans_id: `${this.store.trans_id}`,
      };
      this.store.verifyAccountOperation(form, true).then(() => {
        this.google_token = ''
        if(form.type == 'REMOVE_BONUS'){
          this.showRemoveModal = true;
        }else if(form.type == 'BONUS'){
          this.showAddModal = true
        } 
        let keys = {
        dataRequired: {
          margin_detail: true,
          open_trades: false,
          history: false,
          account_detail: false,
        },
      };
          this.store.setLastSelectedAccount(this.store.lastSelectedAccount,keys,false,'');
          this.store.getAvailableBonus(this.store.lastSelectedAccount);
        })
        .catch((error) => {
          console.log(error);
        });
      this.isRemove = false;
    },
  },
};
</script>
